import { pipe } from 'fp-ts/function';
import { FC } from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '@mews-commander/types';
import { LocalizedCurrencyValue, multiplyNumbersAsDecimals, NumberFormatting, NumberService } from '@mews/framework';
import { getCurrentCurrencyCultureInfo } from '@mews-commander/core/legacy-globalization';
import { getProductCurrency } from '@mews-commander/legacy-entities/src/ducks/products';
import { getProductServiceProductUnitFieldValue } from '../selectors';
import { ProductListProductOwnProps } from '../types';
import { getProductUnitAmountFieldName, getProductUnitCostFieldName } from '../utils';

interface StateProps {
    unitCost?: string;
    unitAmount?: string;
    currency: string;
    currentCultureNumberInfo: NumberFormatting;
}

type ProductListTotalCostFieldProps = StateProps & ProductListProductOwnProps;

const ProductListTotalCostField: FC<ProductListTotalCostFieldProps> = ({
    unitAmount = '0',
    unitCost = '0',
    currency,
    currentCultureNumberInfo,
}) => {
    const unformatUnitCost = NumberService.unformat(unitCost, currentCultureNumberInfo) || 0;
    // @ts-expect-error Argument of type 'string' is not assignable to parameter of type 'number'.
    const result = multiplyNumbersAsDecimals(unitAmount, unformatUnitCost);

    const currencyValue = {
        value: result,
        currency,
    };

    return <LocalizedCurrencyValue value={currencyValue} />;
};

export default pipe(
    ProductListTotalCostField,
    connect<StateProps, {}, ProductListProductOwnProps, ApplicationState>((state, { productId }) => ({
        unitCost: getProductServiceProductUnitFieldValue(state, {
            productId,
            fieldNameResolver: getProductUnitCostFieldName,
        }),
        unitAmount: getProductServiceProductUnitFieldValue(state, {
            productId,
            fieldNameResolver: getProductUnitAmountFieldName,
        }),
        currency: getProductCurrency(state, { id: productId }),
        currentCultureNumberInfo: getCurrentCurrencyCultureInfo(state),
    }))
);
